export default __webpack_public_path__ + "static/app-store-3467efe186a367516fde1296d08754ee.png";